<template>
  <div aria-live="polite" aria-atomic="true" class="z-50 fixed inset-0 flex flex-col items-center px-4 py-6 pointer-events-none">
    <transition-group name="fade"
                    tag="div"
                    class="flex flex-col items-center"
                    enter-active-class="ease-out duration-500"
                    enter-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="ease-in duration-300"
                    leave-class="opacity-100"
                    leave-to-class="opacity-0">
      <Toast
        v-for="toast in toasts"
        :key="toast.id"
        :id="toast.id"
        :type="toast.type"
        :title="toast.title"
        :description="toast.description"
        :duration="toast.duration"
        @close="removeToast"
      />
    </transition-group>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Toast from './toastPopup.vue';
import { useToast } from '../../store/toast.store';

export default defineComponent({
  components: { Toast },
  setup() {
    const { state, removeToast } = useToast();
    return { toasts: state.toasts, removeToast };
  }
});
</script>
